import React from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import TagChip, {linkTypes as LINK_TYPES, tagChipSizes as SIZES} from '@adv-mt/mt-tag-chip'

const TAG_TEST_ID = 'mt-ListTagChips-item'
const tagChipDesign = 'outline'

export default function ListTagChips({items, linkFactory}) {
  return (
    <div className="mt-ListTagChips">
      {items.map((item, i) => {
        const {isSelected, title, url} = item

        const listTagChipsItemClass = cx('mt-ListTagChips-item', {
          'mt-ListTagChips-item--selected': isSelected
        })

        const tagChipType = isSelected ? 'isSelected' : 'clear'

        return (
          <div className={listTagChipsItemClass} key={i} data-testid={TAG_TEST_ID}>
            <TagChip
              design={tagChipDesign}
              size={SIZES.MEDIUM}
              type={tagChipType}
              label={title}
              href={url}
              linkFactory={linkFactory}
              rel={[LINK_TYPES.NOFOLLOW]}
            />
          </div>
        )
      })}
    </div>
  )
}

ListTagChips.displayName = 'ListTagChips'
ListTagChips.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      isSelected: PropTypes.bool
    })
  ).isRequired,
  linkFactory: PropTypes.func
}
